export const getFileMimeTypeSlug = (mimeType: string): string => {
  switch (mimeType) {
    case 'image/jpg':
    case 'image/jpeg': return 'JPG'
    case 'application/pdf': return 'PDF'
    case 'image/png': return 'PNG'
    default: return 'FILE'
  }
}
